import React, { useState, useEffect, useContext, useRef } from "react";
import HeadingText from "../../common/HeadingText/HeadingText";
import FormSectionLayout from "../../layouts/FormSectionLayout";
import TextField from "../../common/TextField/TextField";
import { Container, Form, Row, Col } from "reactstrap";
import RadioButton from "../../common/RadioButton/RadioButton";
import backArrowIcon from "../../../assets/images/back_arrow.svg";
import { SelectDropDown } from "../../common/SelectDropDown/SelectDropDown";
import {
  IAddUpdateCategoryGlobalProps,
  ICategoryGlobalPayload,
  ICoreCategoryGlobal,
} from "../../../interfaces/Index";
import ButtonComponent from "../../common/Button/ButtonComponent";
import LoaderComponent from "../../common/Loader/Loader";
import Toaster from "../../common/Toaster/Toaster";
import { normalizeCategoryGlobalReqPayload } from "../../../normalizer/CategoryGlobalNormalizer";
import { alphaNumericValidator } from "../../../utils/Validators";
import { AbilityContext, Can } from "../../../config/Can";
import MultiSelectDropDown from "../../common/MultiSelectDropDown/MultiSelectDropDown";
import Modal from "../../common/Modal/Modal";
import "./AddUpdateCategoryGlobalPage.scss";
import { untagCategoryZoneApiCall } from "../../../redux/sources/CategoryGlobalSource";

export const untagCategoryZone = async (categoryId: string, zoneId: string) => {
  const zone: any = await untagCategoryZoneApiCall({
    zoneId: zoneId,
    categoryId: categoryId,
  });

  return zone.zone || zone;
};

const AddUpdateCategoryGlobalPage: React.FunctionComponent<
  IAddUpdateCategoryGlobalProps
> = (props: IAddUpdateCategoryGlobalProps) => {
  const ability = useContext(AbilityContext);

  const [categoryState, setCategoryGlobalState] =
    useState<ICategoryGlobalPayload>({
      id: props.selectedCategoryGlobal
        ? props.selectedCategoryGlobal.id || ""
        : "",
      categoryType: props.selectedCategoryGlobal
        ? props.selectedCategoryGlobal.categoryType || "core"
        : "core",
      categoryFeature: props.selectedCategoryGlobal
        ? props.selectedCategoryGlobal.categoryFeature || "DEFAULT"
        : "DEFAULT",
      categoryTitle: props.selectedCategoryGlobal
        ? props.selectedCategoryGlobal.categoryTitle || ""
        : "",
      coreCategory: props.selectedCategoryGlobal
        ? props.selectedCategoryGlobal.coreCategory || "-1"
        : "-1",
      categoryHandle: props.selectedCategoryGlobal
        ? props.selectedCategoryGlobal.categoryHandle || ""
        : "",
      cities: props.selectedCategoryGlobal
        ? props.selectedCategoryGlobal.cities || []
        : [],
    });
  let untagCity: any = useRef([]);
  let taggedCities: any = useRef([]);
  let parentCategoryCities: any = useRef([]);
  const [showModal, setShowModal] = useState(false);
  const [showSubCategoriesGlobal, setShowSubCategoriesGlobal] = useState(
    props.selectedCategoryGlobal
      ? props.selectedCategoryGlobal.categoryType === "core"
        ? false
        : true
      : false
  );

  const [coreCategoriesOptions, setCoreCategories] = useState<
    Array<ICoreCategoryGlobal>
  >([]);

  const [categoryZoneOptions, setCategoryZoneOptions] = useState<any>();

  const [categoryTypes, setCategoryTypes] = useState([
    {
      name: "categoryType",
      buttonText: "Core",
      value: "core",
      checked: categoryState.categoryType === "core" ? true : false,
    },
    {
      name: "categoryType",
      buttonText: "sub-category",
      value: "sub_category",
      checked: categoryState.categoryType === "sub_category" ? true : false,
    },
  ]);

  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    const { getCoreCategoriesGlobal, coreCategories } = props;
    if (coreCategories.length === 0) {
      getCoreCategoriesGlobal();
    }
  }, []);

  useEffect(() => {
    const { coreCategories } = props;
    if (coreCategories.length > 0) {
      setCoreCategories(coreCategories);
    }
  }, [props.coreCategories.length]);

  useEffect(() => {
    const {
      isCategoryGlobalAdded,
      backButtonHandler,
      isCategoryGlobalUpdated,
    } = props;
    isCategoryGlobalAdded && backButtonHandler(true);
    isCategoryGlobalUpdated && backButtonHandler(true);
  }, [props.isCategoryGlobalAdded, props.isCategoryGlobalUpdated]);

  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      alert((error! as any).errors);
      handleToaster(true, (error! as any).errors);
    }
  }, [props.isError]);

  useEffect(() => {
    const { fetchCities } = props;
    fetchCities();
  }, []);

  useEffect(() => {
    const { citiesList, isCityListFetched, selectedCategoryGlobal } = props;
    if (
      isCityListFetched &&
      citiesList &&
      citiesList.length > 0 &&
      selectedCategoryGlobal &&
      selectedCategoryGlobal.cities.length
    ) {
      const sliceCities = selectedCategoryGlobal.cities.slice();
      sliceCities?.map((city, index) => {
        const cityIdMatched = citiesList.findIndex((cityObj) => {
          return cityObj.id === (city as any);
        });
        sliceCities[index] = citiesList && citiesList[cityIdMatched];
      });

      setCategoryGlobalState({
        ...categoryState,
        cities: sliceCities.slice(),
      });
      taggedCities.current = sliceCities.slice();
    }
  }, [
    props.isCityListFetched,
    props.citiesList,
    props.citiesList.length,
    props.selectedCategoryGlobal,
  ]);

  useEffect(() => {
    const { categoriesGlobal, citiesList, isCityListFetched } = props;

    if (categoriesGlobal && citiesList && isCityListFetched) {
      const globalCategories = categoriesGlobal.flat(1);
      const matchedCategoryId = globalCategories.find(
        (x) => x.id === coreCategory
      );

      const matchedCities: any = matchedCategoryId?.cities;

      const sliceCities: any = matchedCities && matchedCities.slice();
      sliceCities?.map((city: any, index: any) => {
        const cityIdMatched = citiesList.findIndex((cityObj) => {
          return cityObj.id === (city as any);
        });
        sliceCities[index] = citiesList && citiesList[cityIdMatched];
        parentCategoryCities.current = [sliceCities[index]];
      });

      setCategoryZoneOptions(sliceCities && sliceCities.slice());
    }
  }, [categoryState.coreCategory, props.citiesList, props.citiesList.length]);

  const closeModal = () => {
    setShowModal(false);
  };

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const { categoryTitle, coreCategory, categoryHandle } = categoryState;
  const { backButtonHandler } = props;

  const radioSelect = (e: any, index: number) => {
    const { name } = e.target;
    let categoryTypeSelected;
    let categoryRadios = categoryTypes.slice();
    categoryRadios.map((cat, i) => {
      if (i === index) {
        cat.checked = true;
        cat.value === "sub_category"
          ? setShowSubCategoriesGlobal(true)
          : setShowSubCategoriesGlobal(false);
        categoryTypeSelected = cat.value;
      } else {
        cat.checked = false;
      }
      return null;
    });
    setCategoryTypes([...categoryRadios]);
    setCategoryGlobalState({
      ...categoryState,
      [name]: categoryTypeSelected,
    });
  };

  const handleGoBackButton = () => {
    backButtonHandler(false);
  };

  const handleChange = (e: any) => {
    const fieldId: string = e.target.id;
    const fieldValue: string = e.target.value;
    setCategoryGlobalState({
      ...categoryState,
      [fieldId]: fieldValue,
    });
  };

  const handleSelectChange = (e: any) => {
    const fieldId: string = e.target.id;
    const selectedIndex: number = e.target.selectedIndex;
    const optionElement = e.target.childNodes[selectedIndex];
    const optionValue = optionElement.value;
    setCategoryGlobalState({
      ...categoryState,
      [fieldId]: optionValue,
    });
  };

  const handleCityChange = async (value: any) => {
    const { isEdit } = props;
    untagCity.current = [...categoryState.cities].filter(
      (x) => !value.includes(x)
    );
    const city = categoryState;
    city.cities = value.slice();

    if (isEdit && untagCity.current.length) {
      const categoryId =
        categoryState.categoryType === "sub_category"
          ? (categoryState.coreCategory as string)
          : (categoryState.id as string);

      const untagCategoryResponse: any = await untagCategoryZone(
        categoryId,
        untagCity.current[0].id
      );
      if (!untagCategoryResponse) {
        setShowModal(!showModal);
      } else {
        setCategoryGlobalState({
          ...city,
        });
      }
    } else {
      setCategoryGlobalState({
        ...city,
      });
    }
  };

  const handleGoBackModalBtn = () => {
    setCategoryGlobalState({
      ...categoryState,
      cities: taggedCities.current,
    });
    closeModal();
  };

  const handleSubmit = () => {
    const { isEdit, createCategoryGlobal, updateCategoryGlobal } = props;
    if (isEdit) {
      const reqPayload = normalizeCategoryGlobalReqPayload(categoryState, true);
      updateCategoryGlobal(reqPayload.id, reqPayload);
    } else {
      const reqPayload = normalizeCategoryGlobalReqPayload(categoryState);
      // Call async action creator
      createCategoryGlobal(reqPayload);
    }
  };

  const validateForm =
    props.dummyValidation || !!(categoryTitle && categoryHandle);

  const headingText = props.isEdit ? "Edit a category" : "Add a category";
  const buttonText = showSubCategoriesGlobal
    ? props.isEdit
      ? "Update sub-category"
      : "Add a sub-category"
    : props.isEdit
    ? "Update core category"
    : "Add a core category";

  const renderCategoryDetail = () => {
    return (
      <FormSectionLayout subTitleText="Category details">
        <RadioButton
          radioButtonArray={categoryTypes}
          label="Types"
          onChange={radioSelect}
          isDisabled={props.isEdit}
        />
        <div className={!showSubCategoriesGlobal ? "hide" : ""}>
          <SelectDropDown
            label="Core Category"
            options={coreCategoriesOptions}
            id="coreCategory"
            handleChange={handleSelectChange}
            value={coreCategory}
            defaultOption={{
              id: "-1",
              value: "",
              text: "Select a category",
            }}
          />
        </div>
        <TextField
          id="categoryTitle"
          label="Title"
          placeholder="e.g. Beverages"
          value={categoryTitle}
          handleChange={handleChange}
          error={alphaNumericValidator(categoryTitle)}
        />

        <TextField
          id="categoryHandle"
          label="Category ID"
          placeholder="CAT-001"
          value={categoryHandle}
          handleChange={handleChange}
        />
      </FormSectionLayout>
    );
  };

  const renderProductVisibilityForm = () => {
    return (
      <div className="form-row">
        <Col>
          <MultiSelectDropDown
            options={
              categoryState.categoryType === "sub_category"
                ? categoryZoneOptions
                : props.citiesList
            }
            label="Tag Cities"
            placeholder="Please select Cities"
            displayValue="name"
            selectedValues={categoryState.cities}
            onChange={handleCityChange}
            onRemove={handleCityChange}
          />
        </Col>
      </div>
    );
  };

  const renderFormButton = () => {
    return (
      <div className="form-row-separator">
        <Row id="addEditButtonRow">
          <Col lg="6">
            {(ability.can("update", "category") ||
              ability.can("create", "category")) && (
              <ButtonComponent
                buttonClass="large-button btn-primary"
                buttonText={buttonText}
                onClickHandler={handleSubmit}
                isDisable={props.isLoading || !validateForm}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <Container fluid>
      {props.isLoading && <LoaderComponent />}

      <Modal
        showModal={showModal}
        modalHeading="Unable to untag city"
        closeModalHandler={closeModal}
        showProgressString={false}
        failedRecords=""
        modalBodyClass="untag-city-search"
        showCloseButton={false}
        closeModalOnBackgroundClick={false}
      >
        <div className="untag-city-desc">
          There are products or categories tagged to this city, please untag
          them and try again.
        </div>
        <ButtonComponent
          buttonClass="btn btn-primary-outline button-large"
          buttonText="Go back"
          onClickHandler={handleGoBackModalBtn}
        />
      </Modal>

      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <Row>
        <Col>
          <div className="back-button">
            <a href="javascript:void(0)" onClick={handleGoBackButton}>
              {" "}
              <span>
                <img src={backArrowIcon} alt="close" />
              </span>{" "}
              Back to Categories
            </a>
          </div>
          <HeadingText text={headingText} isMainHeading={true} />
        </Col>
      </Row>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="category-detail">{renderCategoryDetail()}</div>
            <FormSectionLayout subTitleText="City">
              {renderProductVisibilityForm()}
            </FormSectionLayout>
            <FormSectionLayout subTitleText="">
              {renderFormButton()}
            </FormSectionLayout>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AddUpdateCategoryGlobalPage;
